<template>
    <card>
        <h1 slot="title" >DefShare - Delete</h1>
        <div v-if="showLoading" slot="content" class="loader_spinner"></div>
        <!-- NotFoundView -->
        <div v-if="showNotFound" slot="content">
            <file-not-found />
        </div>
        <button v-if="showNotFound" slot="footer" class="button_submit" v-on:click="uploadForm()">
            {{ localization.label.uploadFile }}
        </button>
        <!-- Downloading -->
        <button v-if="showDeleting" slot="footer" class="button_submit button-disabled" disabled="disabled">
            {{ localization.label.deleting }}
        </button>
        <!-- NormalView -->
        <div v-show="showNormal" slot="content-right">
            <delete-form ref="form" :has-password="passwordRequired"/>
            <re-captcha ref="recaptcha" />
        </div>
        <div v-if="showNormal" slot="content-left" class="center">
            <p class="label-info">
                <span class="label-info-header">{{ localization.label.name }}: </span>
                {{ fileName }}
            </p>
            <p class="label-info">
                <span class="label-info-header">{{ localization.label.size }}: </span> 
                {{ fileLength }}
            </p>
        </div>
        <button v-if="showNormal" slot="footer" class="button_submit" v-on:click="submitForm()">
            {{ localization.label.delete }}
        </button>
    </card>
</template>

<script>
import Card from '@components/Card'
import Api from '@services/Api'
import Localize from '@localize'
import DeleteForm from '@components/DeleteForm'
import ReCaptcha from '@components/ReCaptcha'
import FileNotFound from '@components/FileNotFound'
import Common from '@services/Common'

import { EventBus, Names } from '@/EventBus'

export default {
    components: {
        Card,
        ReCaptcha,
        DeleteForm,
        FileNotFound
    },
    computed: {
        localization () {
            return Localize.deleteView()
        },
        showLoading () {
            return this.loading && !this.fileNotFound && !this.deleting
        },
        showNormal () {
            return !this.loading && !this.fileNotFound && !this.deleting
        },
        showNotFound () {
            return !this.loading && this.fileNotFound && !this.deleting
        },
        showDeleting () {
            return !this.loading && !this.fileNotFound && this.deleting
        }
    },
    data () {
        return {
            loading: true,
            fileNotFound: false,
            deleting: false,

            fileRequestId: this.$route.query.FileRequestId || this.$route.query.fileRequestId || this.$route.query.filerequestid,
            fileId: this.$route.query.FileId || this.$route.query.fileId || this.$route.query.fileid,
            code: this.$route.query.Code || this.$route.query.code,
            fileName: '',
            fileLength: '',

            passwordRequired: false,
        }
    },
    mounted () {
        this.fileInfo()
    },
    methods: {
        uploadForm () {
            this.$router.replace('/')
        },
        async fileInfo () {
            try {
                await Api.serviceInfo()
                let response = await Api.fileInfo(this.fileId, this.fileRequestId)
                response = response.data

                this.fileName = response.fileName
                this.fileLength = Common.getReadableFileSizeString(response.length)
                this.passwordRequired = response.isPasswordRequired
            } catch (error) {
                this.fileNotFound = true

                console.error(error)
                console.error(error.response)
            } finally {
                this.loading = false
            }
        },
        async submitForm () {            
            if (this.$refs.form.isFormValid() && this.$refs.recaptcha.isValid())
            {
                try {                    
                    this.deleting = true
                    
                    await this.delete()

                    this.notify({ status: 200 })
                } catch (error) {
                    this.deleting = false
                    
                    console.error(error)

                    this.$refs.recaptcha.reset()
                    this.notify(error.response)
                }
            }
        },
        async delete () {
            let formData = this.$refs.form.createFormData()
            formData.append('fileRequestId', this.fileRequestId)
            formData.append('fileId', this.fileId)
            formData.append('code', this.code)
            formData.append('token', this.$refs.recaptcha.getToken())

            await Api.serviceInfo()
            await Api.deleteRequest(formData)
        },
        notify (response) {
            if (response != null && response.status == 200) {
                EventBus.$emit(Names.ShowSuccess, this.localization.message.fileDeleted)
            } else if (response != null && response.status == 401) {
                EventBus.$emit(Names.ShowError, this.localization.message.passwordInvalid)    
            } else {
                EventBus.$emit(Names.ShowError, this.localization.message.somethingWentWrong)
            }
        }
    }
}
</script>

<style lang="sass">    
.center
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
</style>
